module.exports = __webpack_public_path__ + "img/DE00784.bac4d03f.png";